export default __webpack_public_path__ + "static/media/zuz-logo-filled-text.7aa47ffd.png";